import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

const baseUrl = `${process.env.REACT_APP_BASE_API}Schedule/stock`

export const getData = createAsyncThunk('stocks/getData', async params => {
  const response = await axios.get(`${baseUrl}/listStockByWarehouse`, { params })
  return {
    params,
    data: response.data.Response.items,
    totalPages: response.data.Response.total_items
  }
})


export const getStockByWarehouse = createAsyncThunk('stocks/getStockByWarehouse', async (warehouseId, { rejectWithValue }) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_BASE_API}Schedule/stock/listStockForAdjustment/${warehouseId}`)
    
    if (response.data.Response.Code === 1) {
      return response.data.Response.Stock
    } else {
      return rejectWithValue('No se pudo cargar el stock para la bodega seleccionada.')
    }
  } catch (error) {
    return rejectWithValue(error.message)
  }
})

export const createAdjustment = createAsyncThunk('stocks/createAdjustment', async (adjustments, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_BASE_API}Schedule/movement/createAdjustment`, {
      Request: {
        CreateAdjustments: adjustments
      }
    })
    if (response.data.Response.Code === 1) {
      return { success: true, message: 'Ajuste realizado con éxito' }
    } else {
      return rejectWithValue(response.data.Response.Description || 'Error al crear el ajuste')
    }
  } catch (error) {
    return rejectWithValue(error.message)
  }
})

const stockSlice = createSlice({
  name: 'stocks',
  initialState: {
    data: [],
    total: 1,
    params: {},
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getData.pending, (state) => {
        state.loading = true
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getStockByWarehouse.pending, (state) => {
        state.loading = true
        state.data = [] // Limpiar el stock anterior al iniciar una nueva carga
        state.error = null
      })
      .addCase(getStockByWarehouse.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload
      })
      .addCase(getStockByWarehouse.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      .addCase(createAdjustment.pending, () => {
        // No se modifica el loading global
      })
      .addCase(createAdjustment.fulfilled, () => {
        // No es necesario hacer nada aquí
      })
      .addCase(createAdjustment.rejected, (state, action) => {
        state.error = action.error.message
      })
  }
})

export default stockSlice.reducer
